import { Injector } from "@angular/core";
import { SimpleSearchListNode } from "../../SimpleSearchListNode";
import { EntityEnum } from "../../EntityEnum";
import { SourceEntityListView } from "../../../Data/MedicinalProductData/SourceEntityListView";
import { SourceAutoUploadEntity } from "../Entity/SourceAutoUploadEntity";
import { BaseNode } from "../../BaseNode";

export class TreeNodeMedicinalProductsSource extends SimpleSearchListNode {
    useHist: boolean = false;
    constructor(injector: Injector, items: any[]|undefined, useHist: boolean) {
        super(injector, new SourceEntityListView(items), 'Sources', useHist ? EntityEnum.sourceHist : EntityEnum.source);
        this.useHist = useHist;
    }


    override addChild(model: any): BaseNode|undefined {
        const labelTemplate = `${model.ev_Code} - ${model.sourcename}`;
        return this.addChildNode(SourceAutoUploadEntity, labelTemplate, this, model, this.useHist, false, false);
        // add specific nodes for this entity
    }

    override getCriteriaFields(): string[] {
        return ['ev_Code', 'sourcename'];
    }

    override getPlaceHolderTemplate(): string {
        return "Search for sources available in the XEVMPD [visibility restrictions may apply] including those owned by your HQ";
    }
}